import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql, useFragment } from 'react-relay';

import { ContentModeFragmentContext } from '../hooks/ContentModeFragmentContext.ts';

import type { ContentModeFragmentProvider_content$key } from './__generated__/ContentModeFragmentProvider_content.graphql.ts';

const ContentModeFragmentProviderContentFragment: GraphQLTaggedNode = graphql`
	fragment ContentModeFragmentProvider_content on Content {
		id
		contentProperties {
			latest {
				contentMode
			}
			draft {
				contentMode
			}
		}
	}
`;

export const ContentModeFragmentProvider: FC<
	PropsWithChildren<{
		contentFragmentRef: ContentModeFragmentProvider_content$key;
	}>
> = ({ children, contentFragmentRef }) => {
	const contentModeFragmentData = useFragment(
		ContentModeFragmentProviderContentFragment,
		contentFragmentRef,
	);

	return (
		<ContentModeFragmentContext.Provider value={contentModeFragmentData}>
			{children}
		</ContentModeFragmentContext.Provider>
	);
};
